import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { ContentState, TopicType, TopicTypeString } from "../../../models/SKArtifact";
import { useNavigationBar } from "../../../context/NavigationContext";
import LoadingPopup from "../../channels/create/LoadingPopup";
import { capitalizeFirstLetter } from "../../../utils/stringFunctions";

const topicData = [
  {
    id: 1,
    icon: "/icons/Entertainment.png",
    topic: TopicType.entertainment,
  },
  {
    id: 2,
    icon: "/icons/FoodandDrink.png",
    topic: TopicType.food,
  },
  {
    id: 3,
    icon: "/icons/Travel.png",
    topic: TopicType.travel,
  },
  {
    id: 4,
    icon: "/icons/Music.png",
    topic: TopicType.music,
  },
  {
    id: 5,
    icon: "/icons/Fashion.png",
    topic: TopicType.fashion,
  },
  {
    id: 6,
    icon: "/icons/HealthandFitness.png",
    topic: TopicType.health,
  },
  {
    id: 7,
    icon: "/icons/Technology.png",
    topic: TopicType.technology,
  },
  {
    id: 8,
    icon: "/icons/Sports.png",
    topic: TopicType.sports,
  },
  {
    id: 9,
    icon: "/icons/Culture.png",
    topic: TopicType.culture,
  },
  {
    id: 10,
    icon: "/icons/Shopping.png",
    topic: TopicType.shopping,
  },
  {
    id: 11,
    icon: "/icons/KidsandFamily.png",
    topic: TopicType.kids,
  },
  {
    id: 12,
    icon: "/icons/Business.png",
    topic: TopicType.business,
  },
  {
    id: 13,
    icon: "/icons/Environment.png",
    topic: TopicType.environment,
  },
  {
    id: 14,
    icon: "/icons/Education.png",
    topic: TopicType.education,
  },
  {
    id: 15,
    icon: "/icons/games.png",
    topic: TopicType.games,
  },
  {
    id: 16,
    icon: "/icons/Books.png",
    topic: TopicType.books,
  },
  {
    id: 17,
    icon: "/icons/Design.png",
    topic: TopicType.design,
  },
];

function SelectTopic() {
  const location = useLocation();
  const editPath = /^\/list\/[^/]+\/edit$/.test(location.pathname);
  const { contentData, updateContentData, isEditable } = useContext(CreateArtifactContext);
  const [isLoading, setIsLoading] = useState(false);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [editable, setEditable] = useState<boolean>(true);
  useEffect(() => {
    if (isEditable) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Content",
      subtitle: "Channel",
      buttonTitle: "Done",
      filterOption: false,
      enableLink: contentData.topic ? true : false,
      onFilter: () => {},
      onNext: () => navigate(-1),
      onClose: () => navigate(-1),
      getActionItems: undefined,
    });
  }, [setNavProps, navigate, contentData]);

  return (
    <div className="p-1 bg-white">
      <LoadingPopup isLoading={isLoading} />
      <div className="flex flex-col">
        <div className="mb-5 flex flex-col space-y-[10px] w-full">
          <div className="mb-5 flex flex-col space-y-[10px] w-full">
            <label className="title_inner_page">Choose the primary topic of your content.</label>
            <label className="notes-class-content">Choose the topic that represents the primary focus of most of your content.</label>
            <div className="mb-5 flex flex-col space-y-[2px] w-full">
              <ul className="space-y-2">
                {topicData.map(item => (
                  <li
                    onClick={() => {
                      editable &&
                        updateContentData({
                          ...contentData,
                          topic: item.topic,
                        });
                    }}
                    key={item.id}
                    className="flex items-center topic-item"
                  >
                    <img
                      src={contentData.topic === item.topic ? "/svg/circlechecked.svg" : "/svg/circle.svg"}
                      alt={TopicTypeString[item.topic]}
                      className="object-cover w-[22px] h-[22px]"
                    />
                    <div className="topic-image-box-updated">
                      <img className="object-contain w-[35px] h-[35px]" src={item.icon} alt={TopicTypeString[item.topic]} />
                    </div>
                    <div className="flex-1">
                      <p className="items-center justify-center radio-button-label">{capitalizeFirstLetter(TopicTypeString[item.topic])}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectTopic;
